import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'react-toastify/dist/ReactToastify.css';
import './assets/main.css';
import HomePage from './pages/HomePage';
import CostCalculationPage from './pages/CostCalculationPage';
import BadmintonSchedulePage from './pages/BadmintonSchedulePage';
import ScheduleCardPage from './pages/ScheduleCardPage';
import CockPage from './pages/CockPage';

const App: React.FC = () => {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/cost-calculation" element={<CostCalculationPage />} />
        <Route path="/badminton-schedule" element={<BadmintonSchedulePage />} />
        <Route path="/schedule-card" element={<ScheduleCardPage />} />
        <Route path="/cock" element={<CockPage />} />
      </Routes>
    </Router>
  );
};

export default App;
